import { agentCategories, type AgentCategoryId } from "@/constants/agents";
import { cn } from "@/lib/utils";

interface AgentCategoryTabsProps {
  selectedCategory: AgentCategoryId;
  onSelect: (category: AgentCategoryId) => void;
}

export function AgentCategoryTabs({
  selectedCategory,
  onSelect,
}: AgentCategoryTabsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-hide py-1">
      {agentCategories.map((category) => (
        <button
          key={category.id}
          onClick={() => onSelect(category.id)}
          className={cn(
            "px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors",
            selectedCategory === category.id
              ? "bg-blue-500 text-white"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          )}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
}
